<style lang="scss" scoped>
.state {
  border-bottom: 1px solid $c-dark-grey;
}

.smalltext {
  margin-bottom: 10px;
}

.header {
  font-weight: bold;
}

.umfrageentry {
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 0px;
  &:nth-child(even) {
    background-color: $c-white;
  }
}
</style>

<template>
  <div class="row state">
    <div class="col-3 mb-3">
      <ModalButton class="modalbutton" link="stopUmfrage" v-if="meta?.current">
        <button>{{ $t('management.feedbacks.stop') }}</button>
      </ModalButton>
      <Modal link="stopUmfrage" title="Evaluierungsrunde stoppen">
        <p>Wollen sie diese Evaluierungsrunde wirklich stoppen?</p>
        <p>Alle offenen Evaluierungen werden im Zuge dessen, abgeschlossen.</p>
        <p>
          <button @click="stop">{{ $t('management.feedbacks.stop') }}</button>
        </p>
      </Modal>
      <button @click="start" v-if="!meta?.current">{{ $t('management.feedbacks.start') }}</button>
    </div>
    <div class="col-12 mb-3" v-if="meta?.current">{{ $t('management.feedbacks.current') }}</div>
  </div>

  <div class="row mt-3 mb-0 header smalltext align-items-center">
    <div class="col-1">#</div>
    <div class="col-3">{{ $t('management.feedbacks.start_text') }}</div>
    <div class="col-4">{{ $t('management.feedbacks.end_text') }}</div>
    <div class="col-4">{{ $t('management.grades.state') }}</div>
  </div>

  <div class="row umfrageentry align-items-center" :key="umfrage.id" v-for="umfrage of umfragen">
    <div class="col-1">{{ umfrage.id }}</div>
    <div class="col-3">{{ format(new Date(umfrage.createdat), 'dd.MM.yyyy kk:mm') }}</div>
    <div class="col-4">{{ format(new Date(umfrage.endedat), 'dd.MM.yyyy kk:mm') }}</div>
    <div class="col-4">{{ umfrage.running ? $t('management.feedbacks.running') : $t('management.feedbacks.finished') }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import Modal from '../../../components/util/Modal.vue';
import ModalButton from '../../../components/util/ModalButton.vue';

export default defineComponent({
  components: {
    Modal,
    ModalButton,
  },
  setup() {
    const store = useStore();
    const meta = ref<{ last: any; current: any }>();
    const umfragen = ref();

    const start = () => {
      store.dispatch('startFeedback').then((res: any) => {
        store.dispatch('addNotification', { message: 'Feedback gestartet' });
        fetch();
      });
    };

    const stop = () => {
      store.dispatch('stopFeedback').then((res: any) => {
        store.dispatch('addNotification', { message: 'Feedback gestoppt' });
        store.dispatch('setModal', { link: 'stopUmfrage', value: false });
        fetch();
      });
    };

    const fetch = () => {
      store.dispatch('fetchFeedbackMeta').then((res: any) => {
        meta.value = res;
      });

      store.dispatch('API', { url: 'admin/umfragen' }).then((res: any) => {
        umfragen.value = res.data.message.sort((a: any, b: any) => {
          if (a.createdat > b.createdat) return -1;
          if (a.createdat < b.createdat) return 1;
          return 0;
        });
      });
    };

    onMounted(() => {
      if (store.getters.hasPerm('feedback.manage')) {
        fetch();
      }
    });

    return {
      meta,
      start,
      stop,
      umfragen,
      format,
    };
  },
});
</script>
